import { observer } from "mobx-react-lite"
import { useEffect, useState } from "react"

import { useScaleApplication } from "@/domains/application/use-scale-application"

import { EpochsView } from "./epochs-view"

export const EpochsComposite = observer(() => {
  const scaleApp = useScaleApplication()

  // Local state for hover interactions
  const [hoveredEpoch, setHoveredEpoch] = useState<number | null>(null)
  const [mousePosition, setMousePosition] = useState<{ x: number; y: number } | null>(null)

  // Local state for "All Epochs" toggle
  const [showAllEpochs, setShowAllEpochs] = useState<boolean>(false)

  // Start historic epochs query when component mounts
  useEffect(() => {
    if (scaleApp?.Epochs?.PageStore) {
      scaleApp.Epochs.PageStore.startHistoricEpochsQuery()
    }

    // Cleanup: stop query and clear historic epochs when component unmounts
    return () => {
      if (scaleApp?.Epochs?.PageStore) {
        scaleApp.Epochs.PageStore.stopHistoricEpochsQuery()
        scaleApp.Epochs.PageStore.clearHistoricEpochs()
      }
    }
  }, [scaleApp])

  const currentEpoch = scaleApp?.Epochs?.PageStore?.currentEpoch
  const allEpochs = scaleApp?.Epochs?.PageStore?.allEpochs ?? []

  // Filter out current epoch from historic epochs for the table
  const historicEpochs = currentEpoch
    ? allEpochs.filter((epoch) => epoch.epochNumber !== currentEpoch.epochNumber)
    : allEpochs

  // Handler for "All Epochs" toggle
  const handleToggleAllEpochs = (checked: boolean): void => {
    setShowAllEpochs(checked)
    if (scaleApp?.Epochs?.PageStore) {
      scaleApp.Epochs.PageStore.toggleAllEpochs(checked)
    }
  }

  return (
    <EpochsView
      currentEpoch={currentEpoch}
      historicEpochs={historicEpochs}
      hoveredEpoch={hoveredEpoch}
      setHoveredEpoch={setHoveredEpoch}
      mousePosition={mousePosition}
      setMousePosition={setMousePosition}
      showAllEpochs={showAllEpochs}
      onToggleAllEpochs={handleToggleAllEpochs}
    />
  )
})
